import QuotaStatRow from './QuotaStatRow';

type Props = {
    percent: number | null;
};

const QuotaPercentRow = ({ percent }: Props) => (
    <QuotaStatRow
        label="settings.usage.usage_percent"
        value={percent !== null ? `${percent}%` : undefined}
        skeletonWidth="w-12"
    />
);

export default QuotaPercentRow;
